// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1IuW1","image":"Header_image__3h-4B","name":"Header_name__3qLLS","info":"Header_info__1bKpo","infoRow":"Header_infoRow__29YOy"};